import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-login',
  imports: [CommonModule],
  templateUrl: './login.html'
})
export class Login implements OnInit {
  error = '';

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.auth.isAuthenticated) {
      await this.router.navigateByUrl('/dashboard');
      return;
    }

    await this.login();
  }

  async login(): Promise<void> {
    this.error = '';
    try {
      await this.auth.login();
    } catch (error) {
      this.error = error instanceof Error ? error.message : 'No se pudo iniciar el acceso con Cognito.';
    }
  }
}
